import { Wallet, Bike, AlertTriangle, BarChart3, Settings } from 'lucide-react';
import { barvaFleku } from './flekyGrid';

/**
 * Miniatura fleku — protějšek `RecipeKatIcon` ze Spižírny.
 *
 * Stejná kostra (zaoblený čtverec v barvě, ikona uvnitř), jen barva nejde
 * z kategorie, ale z fleku samotného — viz `barvaFleku`. Díky tomu se
 * v seznamu orientuješ podle barvy dřív, než přečteš název, přesně jako
 * u surovin.
 */
export default function FlekIkona({ flek, size = 40, radius = 10 }) {
    const barva = barvaFleku(flek);
    const Ikona = flek?.typ === 'bistro_hlavni' ? Wallet : Bike;
    return (
        <span className="inline-flex items-center justify-center flex-shrink-0" style={{
            width: size, height: size, borderRadius: radius,
            background: `${barva}24`, border: `1px solid ${barva}44`, color: barva,
        }}>
            <Ikona size={Math.round(size * 0.46)} />
        </span>
    );
}

/** Táž miniatura pro položky mimo fleky (pohledávky, reporty, konfigurace). */
export const NAPRIC_IKONY = { pohledavky: AlertTriangle, reporty: BarChart3, konfigurace: Settings };

export function NapricIkona({ id, size = 40, radius = 10, barva = '#3B82F6' }) {
    const Ikona = NAPRIC_IKONY[id] ?? Settings;
    return (
        <span className="inline-flex items-center justify-center flex-shrink-0" style={{
            width: size, height: size, borderRadius: radius,
            background: `${barva}18`, border: `1px solid ${barva}33`, color: barva,
        }}>
            <Ikona size={Math.round(size * 0.46)} />
        </span>
    );
}
